import React, { useState }  from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import StartingPage from "./pages/StartingPage";
import ScatterPage from "./pages/ScatterPage";
import LoginPage from "./pages/LoginPage";
import { USERNAME, PASSWORD } from './config';


function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(
        localStorage.getItem('isAuthenticated') === 'true'
    );

    const login = (username, password) => {
      if (username === USERNAME && password === PASSWORD) {
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true'); // Save to localStorage (NOT SECURE)
      } else {
        alert('Invalid credentials');
      }
    };

    const logout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem('isAuthenticated'); // Clear from localStorage
    };

    return (
        <Router>
            <div>
                <Routes>
                    <Route path="/" element={<Navigate to="/start-menu" />}/>
                    <Route path="/login" element={isAuthenticated ? <Navigate to="/start-menu" /> : <LoginPage login={login} />}/>
                    <Route path="/start-menu" element={
                        <PrivateRoute isAuthenticated={isAuthenticated}>
                            <StartingPage logout={logout}/>
                        </PrivateRoute>}
                    />
                    <Route path="/scatter-page" element={
                        <PrivateRoute isAuthenticated={isAuthenticated}>
                            <ScatterPage/>
                        </PrivateRoute>}
                    />
                </Routes>
            </div>
        </Router>
    );
}

function PrivateRoute({ isAuthenticated, children }) {
    return isAuthenticated ? children : <Navigate to="/login" />;
  }

export default App;